import { encodeIns } from 'dmpconnectjsapp-base/utils/insUtils';
import { getBaseName } from "../utils/redirect";

export const getParcoursSoinUrl = (ins, yearIndex, monthIndex, dayIndex) => {
  let url = `${getBaseName(false)}/dmp/${encodeIns(ins)}/parcours-soin`;

  if (Number(yearIndex) >= 0) {
    url = `${url}/${yearIndex}`;

    if (Number(monthIndex) >= 0) {
      url = `${url}/${monthIndex}`;
    }

    if (Number(dayIndex) >= 0) {
      url = `${url}/${dayIndex}`;
    }
  }
  return url;
};
export const medsUrlTypes = {
  HR: 'hr',
  MEDS: 'meds',
};
export const getMedsUrl = (ins, type, hrSection, actCode, cipCode) => {
  let url = `${getBaseName(false)}/dmp/${encodeIns(ins)}/${type}`;

  if (!!actCode && !!cipCode) {
    url = `${url}/${hrSection}`;
  }
  return url;
};

export const getSearchDocsUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}/search-docs`;
export const getDpDmpUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}/dp`;
export const getAldDmpUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}/ald`;
export const getAldVitaleUrl = subSection => `${getBaseName(false)}/ald/${encodeIns(subSection)}`;
export const getAATDmpUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}${getBaseName(false)}/aat`;
export const getAATVitaleUrl = subSection => `${getBaseName(false)}/aat/${encodeIns(subSection)}`;
export const getDocumentsUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}/documents`;
export const getImageryUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}/imagery`;
export const getMobileLandingUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}/menu`;
export const getMobileUploadUrl = ins => `${getBaseName(false)}/upload/${encodeIns(ins)}`;
export const getAdminUpdateUrl = ins => `${getBaseName(false)}/dmp/${encodeIns(ins)}/administration/update`;

export const backPagesTypes = {
  DASHBOARD: 'dashboard',
  DMP: 'dmp',
  PREVIOUS: 'previous',
  MSS: 'mss',
  MOBILE_LANDING: 'mobile-landing',
};

export const getBackPage = (type, state) => {
  const {
    dmpconnectApplication: {
      backPages: {
        [type]: backPage,
      },
    },
  } = state;

  return backPage;
};

export const getHomePagePath = (state) => {
  const {
    dmpConnectPersistedAppConfiguration: {
      // efficienceDP,
      mssClientMode,
    },
  } = state;

  // if (efficienceDP) return '/dp';
  if (mssClientMode) return `${getBaseName(false)}/mss`;
  return `${getBaseName(false)}/home`;
};
